module.exports = __webpack_public_path__ + "_assets/img/null-digitalcard-list.16e4770c.svg";